module.exports = __webpack_public_path__ + "media/application/images/2018/loading-balls-ba3dbe3a6a6abfcf25f3d897ba0648c3.svg";